/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_6_Paragraphs_0Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_6_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_6_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your operating system first, then your processor architecture. A Windows x64 package and a Linux x86_64 package are not interchangeable even if the computers use similar processors. On a Mac, the pinned universal package covers Apple silicon and Intel. If you are uncertain about your machine, read its system information rather than inferring the architecture from the computer’s age or appearance.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_6_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_6_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先确认操作系统，再确认处理器架构。即使处理器类似，Windows x64 安装包与 Linux x86_64 安装包也不能互换。对于 Mac，固定版本的 universal 安装包覆盖 Apple silicon 和 Intel。如果不确定设备情况，应查看系统信息，而不是根据电脑的年代或外观猜测。`)
};

/**
* | output |
* | --- |
* | "Check your operating system first, then your processor architecture. A Windows x64 package and a Linux x86_64 package are not interchangeable even if the com..." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_6_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_6_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_6_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_6_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_6_paragraphs_0(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_6_paragraphs_0(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_6_paragraphs_0 as "gc.search_guides.what_is_gridcraft.sections.6.paragraphs.0" }